import styled from "styled-components"

const ReportSummaryPercentIndicatorInfoValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  text-align: right;
`

export default ReportSummaryPercentIndicatorInfoValue